export const CHART_KEY_NUMERICAL_CONSTS = {
  STAGE_1: 100,
  STAGE_2: 80,
  STAGE_3A: 60,
  STAGE_3B: 40,
  STAGE_4: 30,
  STAGE_5: 15,
  DIALYSIS_ONSET: 15,
  ORIGIN_Y: 0,
  MAX_Y_OFFSET: 20,
  MAX_X: 100,
};

export const CHART_STRINGS = {
  STAGE_1: 'G1',
  STAGE_2: 'G2',
  STAGE_3A: 'G3A',
  STAGE_3B: 'G3B',
  STAGE_4: 'G4',
  STAGE_5: 'G5',
  Y_LABEL_LEFT: 'eGFR (mL/min/1.73 m²)',
  Y_LABEL_RIGHT: 'CKD Stage°',
  X_LABEL: 'Age (years)',
  LEGEND_INTERVENTION_LINE: 'Trajectory with intervention',
  LEGEND_NO_INTERVENTION_LINE: 'Trajectory without intervention',
  LEGEND_PROLONG_DIALYSIS_LINE: 'Prolonging of dialysis onset',
  TREATMENT_EGFR: 'eGFR with treatment',
  NO_TREATMENT_EGFR: 'eGFR without treatment',
  FEATURE_NOTE: 'Treatment initiated',
  TIME_GAINED: 'Time Gained',
  APPROXIMATE_DIALYSIS_LABEL_L1: 'Approximate',
  APPROXIMATE_DIALYSIS_LABEL_L2: 'eGFR at',
  APPROXIMATE_DIALYSIS_LABEL_L3: 'dialysis†',
  YRS_UNIT: 'yrs',
};

export const EARLY_INTERVENTION_TEXTS = {
  'RASi': 'Early intervention with RASi therapy may result in an additional',
  'RASi + SGLT2i':
    'Early intervention with RASi + SGLT2i therapy may result in an additional',
  'RASi + SGLT2i + MRA':
    'Early intervention with RASi + SGLT2i + MRA therapy may result in an additional',
  'RASi + SGLT2i + GLP-1':
    'Early intervention with RASi + SGLT2i + GLP-1 therapy may result in an additional',
  'RASi + SGLT2i + MRA + GLP-1':
    'Early intervention with RASi + SGLT2i + MRA + GLP-1 therapy may result in an additional',
};

export const AGE = {
  MIN: 18,
  MAX: 99,
};

export const EGFR = {
  MIN: 15,
  MAX: 120,
};
